import { useEffect, useRef } from "react"

export function useShiftDragScroll<T extends HTMLElement>() {
  const ref = useRef<T>(null)
  const isDragging = useRef(false)
  const startX = useRef(0)
  const scrollLeft = useRef(0)
  const hasMoved = useRef(false)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const onMouseDown = (e: MouseEvent) => {
      if (!e.shiftKey || e.button !== 0) return
      isDragging.current = true
      hasMoved.current = false
      element.classList.add("dragging")
      startX.current = e.pageX - element.offsetLeft
      scrollLeft.current = element.scrollLeft
      e.preventDefault()
    }

    const onMouseMove = (e: MouseEvent) => {
      if (!isDragging.current) return
      const x = e.pageX - element.offsetLeft
      const walk = x - startX.current
      if (Math.abs(walk) > 3) hasMoved.current = true
      element.scrollLeft = scrollLeft.current - walk
    }

    const onMouseUp = () => {
      isDragging.current = false
      element.classList.remove("dragging")
    }

    const onClick = (e: MouseEvent) => {
      if (hasMoved.current) {
        e.preventDefault()
        e.stopPropagation()
        hasMoved.current = false
      }
    }

    element.addEventListener("mousedown", onMouseDown)
    window.addEventListener("mousemove", onMouseMove)
    window.addEventListener("mouseup", onMouseUp)
    element.addEventListener("click", onClick, true)

    return () => {
      element.removeEventListener("mousedown", onMouseDown)
      window.removeEventListener("mousemove", onMouseMove)
      window.removeEventListener("mouseup", onMouseUp)
      element.removeEventListener("click", onClick, true)
    }
  }, [])

  return ref
}
